import { Injectable } from '@angular/core';
import { DataService } from '../data/data.service';
import { Observable } from 'rxjs';
import { Faction, Aspect, Prototype } from '@xanadu/model';
import { HttpClient } from '@angular/common/http';
import { UrlHelper } from '../url-helper';

@Injectable({
    providedIn: 'root'
})
export class AspectService {

    constructor(
        private readonly http: HttpClient,
        private readonly dataService: DataService,
        private readonly urlHelper: UrlHelper
    ) {
    }

    public delete<T extends Aspect | Prototype | Faction>(document: T): Observable<T> {
        const result = this.dataService.delete<T>(document);
        return result;
    }

    public checkDuplicates(aspect: { id: string, data: any }): Observable<any> {
        return this.http.post<any>(`${this.urlHelper.for(Aspect)}/duplicate`, aspect);
    }

    public checkUsage(aspect: Aspect): Observable<any> {
        return this.http.get<any>(`${this.urlHelper.for(Aspect)}/usage/${aspect._id}`);
    }
}
